import {AbstractTimeSelector} from '@gongxigames/framework/integrations/pop/sessionTimer/timeSelector/TimeSelector';

export class MobileDropDownTimeSelector extends AbstractTimeSelector<HTMLSelectElement> {
    protected initView(times: number[], defaultTimeIndex: number): void {
        this.view = document.createElement('select');
        this.view.onchange = this.onChange.bind(this);
        this.view.value = times[defaultTimeIndex] + ' min';

        times.forEach(this.createSelectButton.bind(this));
    }

    protected createSelectButton(time: number): void {
        const option = document.createElement('option');

        option.textContent = time + ' min';
        option.value = time.toString();

        this.view.appendChild(option);
    }

    protected onChange(): void {
        this._onSelectCallback(Number(this.view.value));
    }
}
